<ion-avatar (click)="viewAction()" [ngClass]="{'viewed':viewed}">
  <img 
  class="fade-in"
  [defaultImage]="assetLinksService.avatarLoading" 
  [lazyLoad]="shop.logo" 
  [errorImage]="assetLinksService.noImage"/>
</ion-avatar>